import React from 'react';
import { Box } from '@chakra-ui/core';
export const BottomSpacer = () => <Box minH={['80px', '64px']} />;
